import { formatters } from "@tokenterminal/core/utils/sharedFormatter"
import clsx from "clsx"

import {
  negativeStatusCss,
  positiveStatusCss,
} from "components/v3/TrendValue/TrendValue.css"
import numeral from "numeral"

export const formatNumber = (
  value: number,
  numberFormat?: string,
  prefix?: string
) => {
  if (value === null) {
    return ""
  }

  // Less than 1e-6 is considered to be 0, numberal will show NAN
  if (value < 1e-6 && value > 0) {
    return `${prefix ? prefix : ""}0`
  }

  if (numberFormat === "consistent") {
    const times1000 = Number(value) / 1000

    return numeral(times1000).format(`${prefix ? prefix : ""}0,0`) + " K"
  }

  const format =
    numberFormat === "compact"
      ? `${prefix ? prefix : ""}0.0 a`
      : `${prefix ? prefix : ""}0,0.[0000]`

  return formatters.number({ value, format })
}

export const CHART_VALUE_CELL_DATA_TYPES: Record<
  string,
  (value: number, numberFormat?: string) => string | JSX.Element
> = {
  number: (value: number, numberFormat?: string) => {
    return (
      <span className="uppercase">{formatNumber(value, numberFormat)}</span>
    )
  },
  currency: (value: number, numberFormat?: string) => {
    return (
      <span className="uppercase">
        {formatNumber(value, numberFormat, "$")}
      </span>
    )
  },
  trend: (value: number) => {
    if (typeof value !== "number") return ""
    const isPositive = value > 0

    return (
      <span
        className={clsx({
          [positiveStatusCss]: isPositive,
          [negativeStatusCss]: !isPositive,
        })}
      >
        {isPositive ? "+" : ""}
        {(value * 100).toFixed(1)}%
      </span>
    )
  },
  change: (value: number) => formatters.percent({ value }),
  percentage: (value: number) => formatters.percent({ value }),
  time: (value: number) => formatters.time({ value }),
  accurateCurrency: (value: number) =>
    formatters.price({ value, format: "$0,000.00" }),
  accurateCurrencyThreeDecimals: (value: number) => {
    if (value < 0.001) {
      return `< $0.000`
    }

    return formatters.price({ value, format: "$0,000.000" })
  },
  ratio: (value: number) => formatters.ratio({ value }),
}
